import React from 'react';
import { CONTACT_EMAIL } from '../data/site';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact">
      <div className="contact__container">
        <div className="contact__head">
          <p className="eyebrow">İletişim</p>
          <h1 className="contact__title">Bize yazın</h1>
          <p className="contact__intro">
            Travel Istanbul hakkında soru, öneri ve destek talepleriniz için
            e-posta gönderin; en kısa sürede dönüş yapıyoruz.
          </p>
        </div>

        <div className="contact__card">
          <p className="contact__label">E-posta</p>
          <a className="contact__email" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
          <p className="contact__note">
            Uygulamayla ilgili teknik bir sorun bildiriyorsanız, kullandığınız
            cihaz modelini ve sorunun ne zaman oluştuğunu da yazmanız çözümü
            hızlandırır.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
